import { useCallback, useRef } from 'react';
import { isNil } from 'lodash';

interface RequestRef {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request: () => Promise<any>;
    cancel: (message?: string) => void;
}

const useAutocompleteRequest = () => {
    const getRequestRef = useRef<Nullable<RequestRef>>();

    const cancelRequest = useCallback((message = null) => {
        if (!isNil(getRequestRef.current)) {
            getRequestRef.current.cancel(message ?? 'useAutocompleteRequest: cancelRequest');
        }
    }, []);

    const getAutocompleteRequest = useCallback(
        (getRequest) => {
            cancelRequest();
            getRequestRef.current = getRequest();

            return getRequestRef.current as RequestRef;
        },
        [cancelRequest],
    );

    return { getAutocompleteRequest, cancelRequest };
};

export default useAutocompleteRequest;
